"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// TODO: De-duplicate with app itself
var antd_1 = require("antd");
var Quiz_1 = __importDefault(require("../Quiz"));
var HTMLContent_1 = __importDefault(require("../HTMLContent"));
var TGCPreviewHeader_1 = __importDefault(require("../TGCPreviewHeader"));
var TGCPreviewContent_1 = __importDefault(require("../TGCPreviewContent"));
var styles_1 = require("../../styles");
var utils_1 = require("../../utils");
var styles = __assign(__assign({}, styles_1.pageAndStationStyles), { stationPreview: {
        border: "4px solid #333",
        borderRadius: 9,
        paddingBottom: 16,
        overflow: "hidden",
        maxWidth: 768,
    }, coordinatesBox: {
        display: "flex",
        flexDirection: "column",
        paddingTop: 8,
        borderTopColor: "rgba(255, 255, 255, 0.3)",
        borderTopWidth: 1,
    }, coordinatesTitle: __assign({ color: "white", fontWeight: "bold" }, styles_1.pageAndStationStyles.textShadow), coordinatesItem: __assign({ color: "white", marginTop: 4 }, styles_1.pageAndStationStyles.textShadow), contentItem: {
        borderTop: "2px solid #F9F9F9",
        padding: 16,
        paddingBottom: 0,
    }, quiz: { marginBottom: 8 }, galleryItem: {
        display: "inline-block",
        verticalAlign: "top",
        paddingRight: 16,
        paddingBottom: 8,
    } });
var RenderedContent = react_1.default.memo(function (_a) {
    var _b, _c, _d;
    var id = _a.id, content = _a.content;
    var _e = (0, react_1.useState)(false), showMore = _e[0], setShowMore = _e[1];
    switch (content.content_type) {
        case "html":
            return react_1.default.createElement(react_1.default.Fragment, null,
                content.title ? react_1.default.createElement(antd_1.Typography.Title, { level: 4 }, content.title) : null,
                react_1.default.createElement(HTMLContent_1.default, { id: "".concat(id, "-content-before"), htmlContent: (_b = content.content_before_fold) !== null && _b !== void 0 ? _b : "" }),
                (content.content_after_fold && content.content_after_fold !== "<p><br></p>")
                    ? react_1.default.createElement(antd_1.Button, { onClick: function () { return setShowMore(!showMore); }, style: { marginBottom: 16 } }, showMore ? "HIDE" : "READ MORE") : null,
                showMore
                    ? react_1.default.createElement(HTMLContent_1.default, { id: "".concat(id, "-content-after"), htmlContent: (_c = content.content_after_fold) !== null && _c !== void 0 ? _c : "" })
                    : null);
        case "gallery":
            return react_1.default.createElement(react_1.default.Fragment, null,
                content.title ? react_1.default.createElement(antd_1.Typography.Title, { level: 4 }, content.title) : null,
                react_1.default.createElement(HTMLContent_1.default, { id: "".concat(id, "-gallery-content"), htmlContent: (_d = content.description) !== null && _d !== void 0 ? _d : "" }),
                react_1.default.createElement(antd_1.Image.PreviewGroup, null, content.items.map(function (i) { return (react_1.default.createElement("div", { key: i.asset, style: styles.galleryItem },
                    react_1.default.createElement(antd_1.Image, { height: 180, src: (0, utils_1.assetIdToBytesUrl)(i.asset), alt: i.caption }),
                    " ",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(antd_1.Typography.Text, null, i.caption))); })));
        case "quiz":
            return react_1.default.createElement(Quiz_1.default, __assign({}, content, { style: styles.quiz }));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
});
var StationPreview = react_1.default.memo(function (_a) {
    var long_title = _a.long_title, subtitle = _a.subtitle, coordinates_utm = _a.coordinates_utm, header_image = _a.header_image, contents = _a.contents;
    var _b = coordinates_utm !== null && coordinates_utm !== void 0 ? coordinates_utm : {}, crs = _b.crs, zone = _b.zone, north = _b.north, east = _b.east;
    return react_1.default.createElement("div", { className: "tgc-preview station-preview", style: styles.stationPreview },
        react_1.default.createElement(TGCPreviewHeader_1.default, { headerImage: header_image, longTitle: long_title, subtitle: subtitle }, coordinates_utm ? (react_1.default.createElement("div", { style: styles.coordinatesBox },
            react_1.default.createElement("span", { style: styles.coordinatesTitle },
                "UTM Coordinates (", crs !== null && crs !== void 0 ? crs : "",
                " Zone ", zone !== null && zone !== void 0 ? zone : "",
                ")"),
            react_1.default.createElement("span", { style: styles.coordinatesItem },
                react_1.default.createElement("span", { style: styles.boldText }, "East:"),
                " ", east !== null && east !== void 0 ? east : ""),
            react_1.default.createElement("span", { style: styles.coordinatesItem },
                react_1.default.createElement("span", { style: styles.boldText }, "North:"),
                " ", north !== null && north !== void 0 ? north : ""))) : null),
        react_1.default.createElement(TGCPreviewContent_1.default, null, (contents !== null && contents !== void 0 ? contents : []).map(function (c, i) { return react_1.default.createElement("div", { key: i, style: styles.contentItem },
            react_1.default.createElement(RenderedContent, { id: "station-".concat(i), content: c })); })));
});
exports.default = StationPreview;
